import { StepStatus } from "../../ChangeProcess.types";
import { SiteTaskPhase } from "../../components/SiteTaskPhase";
import { AssignmentType as EnergyAssignmentType } from "../../EnergyWizard/EnergyWizard";
import { AssignmentType as OnboardingAssignmentType } from "../OnboardingWizard.constants";

interface OnboardingPhaseProps {
  type: OnboardingAssignmentType | EnergyAssignmentType;
  isDone: boolean;
  children?: React.ReactNode;
}

function OnboardingPhase({ type, isDone, children }: OnboardingPhaseProps) {
  const AssignmentInfoText: Partial<
    Record<OnboardingAssignmentType | EnergyAssignmentType, string>
  > = {
    [OnboardingAssignmentType.Configuration]:
      "Ergänzen Sie z.B. Allgemeine Daten, Daten zu NVP",
    [OnboardingAssignmentType.Regulatory]:
      "Ergänzen Sie z.B. steuerrechtliche Daten, Angaben zu Stromlieferung oder zu Erzeugungsanlagen",
    [OnboardingAssignmentType.Vollmachten]:
      "Geben Sie uns Ihre Vollmacht für die Abwicklung",
    [EnergyAssignmentType.MeasurementData]: "Historische Messdaten bestätigen"
  };

  return (
    <SiteTaskPhase
      infoText={AssignmentInfoText[type]}
      label={type}
      status={isDone ? StepStatus.done : StepStatus.open}
    >
      {children}
    </SiteTaskPhase>
  );
}

export { OnboardingPhase };
